import styles from './index.module.sass';
import PlusSvg from '@/modules/mixing/images/plus.svg';
import DeleteSvg from '@/modules/mixing/images/delete.svg';
import { SelectBunker } from '../select';
import { multiSectionItem } from '../../hooks';

export const MultipleOption = ({
  item,
  options,
  setMultiSectionItemValue,
  addMultiSectionItem,
  num,
  isLast,
  removeMultiSectionItem,
}: IMultipleOption) => {
  return (
    <div className={styles.multiple}>
      <div className={styles.selector__multiple}>
        {isLast ? (
          <img src={PlusSvg} alt="icon" onClick={addMultiSectionItem} />
        ) : (
          <img src={DeleteSvg} alt="icon" onClick={() => removeMultiSectionItem(num)} />
        )}

        <div className={styles.square}></div>
      </div>
      <div className={styles.select__form}>
        <SelectBunker
          bunker={item.items[0]}
          onChange={(item: any) => {
            setMultiSectionItemValue({
              label: item.label,
              id: item.value,
              itemIdx: num,
              i: 0,
            });
          }}
          options={options.filter((item: any) => item.type === 1)}
        />
        <SelectBunker
          bunker={item.items[1]}
          onChange={(item: any) => {
            setMultiSectionItemValue({
              label: item.label,
              id: item.value,
              itemIdx: num,
              i: 1,
            });
          }}
          options={options.filter((item: any) => item.type === 1)}
        />
      </div>
    </div>
  );
};

interface IMultipleOption {
  removeMultiSectionItem: (val: number) => void;
  isLast?: boolean;
  num: number;
  item: multiSectionItem;
  options: any;
  addMultiSectionItem: () => void;
  setMultiSectionItemValue: (args: {
    label: string;
    id: number;
    itemIdx: number;
    i: number;
  }) => void;
}
